import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { navigate } from "gatsby";
import {
	AES_Encryption,
	GetDataFromServer,
	SetParameter,
	ValidatePhone,
} from "../../../../hooks";
import { APP_ID, REGEX, SERVER_URL } from "../../../../constants/index";
import { useAlert } from "react-alert";
import Calendario from "../../../atoms/Calendario";
import AlertModal from "../../../atoms/AlertModal";
import Error_Img from "../../../../assets/images/error.png";
import { FaAngleDoubleLeft } from "react-icons/fa";
import { ValidateAll } from "./modal-validation.helper";

const AutoForm = ({ Heading = "", type, message, img, isImage }) => {
	const alert = useAlert();
	const [errors, setErrors] = useState({});
	const [tab, setTab] = useState(1);
	const [years, setYears] = useState([]);
	const [marca, setMarca] = useState([]);
	const [subMarca, setSubMarca] = useState([]);
	const [description, setDescription] = useState([]);
	const [selectedYear, setSelectedYear] = useState();
	const [selectedMarca, setSelectedMarca] = useState();
	const [selectedSubMarca, setSelectedSubMarca] = useState();
	const [data, setData] = useState({
		nombre: "",
		appaterno: "",
		apmaterno: "",
		cumpleanios: "",
		genero: "1",
		nacionalidad: "1",
		telefono: "",
		email: "",
		anio: "",
		version: "",
		descripcion: "",
		marca: "",
		plan: "1",
		pagos: "1",
		cp: "",
		id_cotizacion: "0",
		edad: "",
		sub_marca: "",
		state: "",
		delegation: "",
		street: "",
		colony: [],
		acceptTerms: false,
		acceptPrivacy: false,
		estado: [],
		municipio: [],
		colonia: "",
	});
	const [modalAlert, setAlert] = useState({
		show: false,
		reason: null,
		img: null,
		heading: "",
		content: "",
		btn: "",
		subContent: "",
	});
	const [disabled, setIsDisabled] = useState({
		marca: true,
		subMarca: true,
		description: true,
	});

	useEffect(() => {
		const encryptedString = AES_Encryption(APP_ID);
		const url = `${SERVER_URL}bts_ws_marcas_modelos.aspx`;

		if (years.length === 0) {
			GetDataFromServer(url, encryptedString, (err, response) => {
				if (err) alert.show(err.message);
				if (response) {
					const { data: _data } = response;
					setYears(_data);
				}
			});
		}
	}, []);

	useEffect(() => {
		if (message?.type == "error") {
			setAlert({
				show: true,
				heading: "iUps, parece que hubo un error!",
				content:
					message?.text ||
					"Por favor verifica que los dalos sean los correctos.",
				img: Error_Img,
				btn: "Aceptar",
			});
		}
	}, []);

	const onYearChange = (value) => {
		setSelectedYear(value);
		setData({ ...data, anio: value });
	};

	const onMarcaChange = (value) => {
		setSelectedMarca(value);
		setData({ ...data, marca: value });
	};

	const onSubMarcaChange = (value) => {
		setSelectedSubMarca(value);

		setData({ ...data, sub_marca: value });
	};

	const onClickHandler = async () => {
		let ERR = {};
		if (selectedYear && selectedMarca && selectedSubMarca && data.descripcion) {
			if (data.acceptTerms && data.acceptPrivacy) {
				const date = new Date(data.cumpleanios);


				data.colony = [data.colonia]

				const params = SetParameter(
					{
						...data,
						plan: "1",
						pagos: "1",
						id_cotizacion: "0",
						cumpleanios: date.getFullYear() +
									"-" +
									("0" + (date.getMonth() + 1)).slice(-2) +
									"-" +
									("0" + date.getDate()).slice(-2),
						edad: calcularEdad(date)
					},
					APP_ID,
				);

				const descripcion = data.descripcion;
				navigate("/quote-loading", { state: { params, descripcion, data } });
				setErrors({});
			} else {
				if (!data.acceptTerms) {
					ERR = { ...ERR, acceptTerms: true };
				}
				if (!data.acceptPrivacy) {
					ERR = { ...ERR, acceptPrivacy: true };
				}

				setErrors({ ...errors, ...ERR });
				alert.show("Por favor acepte nuestros términos para continuar.");
			}
			return;
		}
		if (!selectedYear || selectedYear.length == 0) {
			ERR = { ...ERR, selectedYear: true };
		} else {
			let newErr = errors;
			delete newErr["selectedYear"];
			setErrors(newErr);
		}
		if (!selectedMarca || selectedMarca.length == 0) {
			ERR = { ...ERR, selectedMarca: true };
		} else {
			let newErr = errors;
			delete newErr["selectedMarca"];
			setErrors(newErr);
		}
		if (!selectedSubMarca || selectedSubMarca.length == 0) {
			ERR = { ...ERR, selectedSubMarca: true };
		} else {
			let newErr = errors;
			delete newErr["selectedSubMarca"];
			setErrors(newErr);
		}

		if (!data.descripcion || data.descripcion.length == 0) {
			ERR = { ...ERR, descripcion: true };
		} else {
			let newErr = errors;
			delete newErr["descripcion"];
			setErrors(newErr);
		}

		setErrors({ ...errors, ...ERR });
		alert.show("Por favor complete todos los campos");
	};

	const formChangeHandler = (e) => {
		const name = e.target.name;
		const value = e.target.value;
		let elem_type = e.target.type;


		if (name == "cumpleanios") {
			elem_type = "date";
		} else if (name == "telefono") {
			elem_type = "phone";
		} else if (name == "email") {
			elem_type = "email";
		} else if (name == "cp") {
			elem_type = "number";
		} else if (name == "descripcion") {
			elem_type = "select";
		}


		if (!ValidateAll(elem_type, value)) {
			setErrors({ ...errors, [name]: true });
		} 
		else {
			let newErr = errors;
			delete newErr[name];
			setErrors(newErr);
		}
		if (name == "descripcion") {
			const { descripcion, version } = description.filter(
				(desc) => desc.version == value,
			)[0];
			setData({ ...data, descripcion: descripcion || "", version });
		} else if (name == "acceptTerms" || name == "acceptPrivacy") {
			setData({ ...data, [name]: e.target.checked });
		} else if (name == "cp") {
			if (value.length < 6) {
				if (value.length == 5) {
					const encryptedString = AES_Encryption(
						SetParameter({ cp: value }, APP_ID),
					);

					const url = `${SERVER_URL}bts_ws_get_zip_code_data.aspx`;
					return GetDataFromServer(url, encryptedString, (err, res) => {
						const { response, error_message, error } = err;
						if (error) alert.show(error_message);
						if (response.length == 0) {
							return setData({
								...data,
								estado: [],
								municipio: [],
								colony: [],
								[name]: value,
							});
						}
						return setData({
							...data,
							estado: [...new Set(response.map((a) => a.estado))],
							municipio: [...new Set(response.map((a) => a.municipio))],
							state: [...new Set(response.map((a) => a.estado))][0],
							delegation: [...new Set(response.map((a) => a.municipio))][0],
							colonia: [],
							colony: [...new Set(response.map((a) => a.asentamiento))],
							[name]: value,
						});
					});
				} else {
					return setData({ ...data, [name]: value });
				}
			}
		} else {
			return setData({ ...data, [name]: value });
		}

		// console.log("check" ,data.acceptPrivacy)
	};
	// Get Marca
	useEffect(() => {
		if (selectedYear) {
			const encryptedString = AES_Encryption(`${APP_ID}&anio=${selectedYear}`);
			const url = SERVER_URL + "bts_ws_marcas.aspx";

			GetDataFromServer(url, encryptedString, (err, response) => {
				if (err) alert.show(err.message);
				if (response) {
					setMarca(response.data);
					setIsDisabled({ ...disabled, marca: false });
				}
			});
		}
	}, [selectedYear]);
	// Get Sub Marcas
	useEffect(() => {
		if (selectedMarca) {
			const encryptedString = AES_Encryption(
				`${APP_ID}&anio=${selectedYear}&marca=${selectedMarca}`,
			);

			const url = SERVER_URL + "bts_ws_marcas_submarcas.aspx";

			GetDataFromServer(url, encryptedString, (err, response) => {
				if (err) alert.show(err.message);

				if (response) {
					setSubMarca(response.data);
					setIsDisabled({ ...disabled, subMarca: false });
				}
			});
		}
	}, [selectedMarca]);
	// Get Description
	useEffect(() => {
		if (selectedSubMarca) {
			const encryptedString = AES_Encryption(
				`${APP_ID}&anio=${selectedYear}&marca=${selectedMarca}&submarca=${selectedSubMarca}`,
			);
			const url = SERVER_URL + "bts_ws_marcas_versiones.aspx";
			GetDataFromServer(url, encryptedString, (err, response) => {
				if (err) alert.show(err.message);

				if (response) {
					const resp = response.data;
					setDescription(resp);
				}
			});
		}
	}, [selectedSubMarca]);

	const validateForm = (id) => {
		const {
			nombre,
			apmaterno,
			appaterno,
			email,
			telefono,
			cp,
			colony,
			state,
			delegation,
			street,
			cumpleanios,
		} = data;

		if (id === 1) {

			


			if (
				nombre.length !== 0 &&
				apmaterno.length !== 0 &&
				appaterno.length !== 0 &&
				email.length !== 0 &&
				telefono.length !== 0 &&
				cp.length !== 0 &&
				colony.length !== 0 &&
				street.length !== 0 &&
				state.length !== 0 &&
				!isNaN(new Date(cumpleanios).getTime()) &&
				delegation.length !== 0
			) {
				const emailValidate = String(email).toLowerCase().match(REGEX["email"]);
				const phoneValidate = telefono.match(REGEX["phone"]);


				if (
					emailValidate &&
					phoneValidate &&
					REGEX["text"].test(nombre) &&
					REGEX["text"].test(apmaterno) &&
					REGEX["text"].test(appaterno) &&
					!REGEX["text"].test(telefono) &&
					telefono.length <= 10 &&
					REGEX["number"].test(cp) &&
					telefono.length <= 10
				) {
					setErrors({});
					setTab(2);
				} else {
					if (!emailValidate) {
						setErrors({ ...errors, ...{ email: true } });
						alert.show("el correo electrónico no tiene el formato correcto");
					}
					if (!REGEX["text"].test(nombre)) {
						setErrors({ ...errors, ...{ nombre: true } });
						return alert.show("Este campo sólo admite letras");
					}
					if (!REGEX["text"].test(apmaterno)) {
						setErrors({ ...errors, ...{ apmaterno: true } });
						return alert.show("Este campo sólo admite letras");
					}
					if (!REGEX["text"].test(appaterno)) {
						setErrors({ ...errors, ...{ appaterno: true } });
						return alert.show("Este campo sólo admite letras");
					}
					if (REGEX["text"].test(telefono) || !ValidatePhone(telefono, 10)) {
						setErrors({ ...errors, ...{ telefono: true } });
						return alert.show("Este campo sólo admite números");
					}
					// if (!phoneValidate || telefono.length > 10) {
					// 	setErrors({ ...errors, ...{ telefono: true } });
					// 	return alert.show(
					// 		"",
					// 	);
					// }
					if (!REGEX["number"].test(cp)) {
						setErrors({ ...errors, ...{ cp: true } });
						alert.show("Este campo sólo admite números");
					}
				}
			} else {
				let ERR = {};
				if (nombre.length == 0) {
					ERR = { ...ERR, nombre: true };
				} else {
					let newErr = errors;
					delete newErr["nombre"];
					setErrors(newErr);
				}
				if (apmaterno.length == 0) {
					ERR = { ...ERR, apmaterno: true };
				} else {
					let newErr = errors;
					delete newErr["apmaterno"];
					setErrors(newErr);
				}
				if (street.length == 0) {
					ERR = { ...ERR, street: true };
				} else {
					let newErr = errors;
					delete newErr["street"];
					setErrors(newErr);
				}
				if (delegation.length == 0) {
					ERR = { ...ERR, delegation: true };
				} else {
					let newErr = errors;
					delete newErr["delegation"];
					setErrors(newErr);
				}
				if (state.length == 0) {
					ERR = { ...ERR, state: true };
				} else {
					let newErr = errors;
					delete newErr["state"];
					setErrors(newErr);
				}
				if (isNaN(new Date(cumpleanios).getTime())) {
					ERR = { ...ERR, cumpleanios: true };
				} else {
					let newErr = errors;
					delete newErr["cumpleanios"];
					setErrors(newErr);
				}
				if (colony.length == 0) {
					ERR = { ...ERR, colony: true };
				} else {
					let newErr = errors;
					delete newErr["colony"];
					setErrors(newErr);
				}
				if (cp.length == 0) {
					ERR = { ...ERR, cp: true };
				} else {
					let newErr = errors;
					delete newErr["cp"];
					setErrors(newErr);
				}
				if (appaterno.length == 0) {
					ERR = { ...ERR, appaterno: true };
				} else {
					let newErr = errors;
					delete newErr["appaterno"];
					setErrors(newErr);
				}
				if (email.length == 0) {
					ERR = { ...ERR, email: true };
				} else {
					let newErr = errors;
					delete newErr["email"];
					setErrors(newErr);
				}
				if (telefono.length == 0) {
					ERR = { ...ERR, telefono: true };
				} else {
					let newErr = errors;
					delete newErr["telefono"];
					setErrors(newErr);
				}

				setErrors({ ...errors, ...ERR });
				alert.show("Por favor complete todos los campos");
			}
		}
	};

	return (
		<Wrapper
			className='p-4'
			style={{
				minHeight: 550,
				background: "#5a68a1",
			}}>
			<div
				className='text-center'
				style={{
					position: "relative",
				}}>
				<Title>{Heading}</Title> &nbsp;{" "}
				{isImage && (
					<img
						style={{
							filter: "invert(1)",
							position: "absolute",
							right: 0,
							top: 0,
							width: "100%",
							maxWidth: 30,
							height: "auto",
						}}
						src={img}
						alt='logo'
					/>
				)}
				<div
					style={{
						display: "flex",
						justifyContent: "center",
					}}>
					{[1, 2].map((c_tab) => (
						<Tabs key={c_tab} className={`${tab === c_tab && `active`}`}>
							{c_tab}
						</Tabs>
					))}
				</div>
			</div>
			<>
				{tab === 1 ? (
					<Step1
						errors={errors}
						data={data}
						formChangeHandler={formChangeHandler}
						setData={setData}
						validateForm={validateForm}
						type={type}
					/>
				) : (
					<Step2
						errors={errors}
						type={type}
						data={data}
						onYearChange={onYearChange}
						years={years}
						selectedYear={selectedYear}
						disabled={disabled}
						formChangeHandler={formChangeHandler}
						description={description}
						onMarcaChange={onMarcaChange}
						marca={marca}
						onSubMarcaChange={onSubMarcaChange}
						subMarca={subMarca}
						selectedMarca={selectedMarca}
						selectedSubMarca={selectedSubMarca}
						tab={tab}
						onClickHandler={() => {
							setErrors({});
							onClickHandler();
						}}
						validateForm={validateForm}
					/>
				)}

				{/* Modal Alert to show success or error messages */}
				{modalAlert.show && (
					<AlertModal
						heading={modalAlert.heading}
						content={modalAlert.content}
						subContent={modalAlert.subContent}
						img={modalAlert.img}
						btn={modalAlert.btn}
						modalShow={modalAlert.show}
						setModalShow={() => setAlert({ ...modalAlert, show: false })}
					/>
				)}
			</>
		</Wrapper>
	);
};

const Step1 = ({
	errors,
	data,
	formChangeHandler,
	setData,
	validateForm,
	type,
}) => {
	return (
		<>
			<div className='row'>
				<div className='col-sm-12'>
					<label style={{ color: "white" }}>Nombre(s)*</label>
					<input
						className='form-control'
						type='text'
						name='nombre'
						style={errors?.nombre ? { borderColor: "red" } : {}}
						value={data?.nombre}
						onChange={formChangeHandler}
					/>
				</div>
			</div>
			<div className='row'>
				<div className='col-sm-12 col-md-6'>
					<label style={{ color: "white" }}>Apellido Paterno*</label>
					<input
						className='form-control'
						type='text'
						name='appaterno'
						style={errors?.appaterno ? { borderColor: "red" } : {}}
						value={data?.appaterno}
						onChange={formChangeHandler}
					/>
				</div>
				<div className='col-sm-12 col-md-6'>
					<label style={{ color: "white" }}>Apellido Materno*</label>
					<input
						className='form-control'
						type='text'
						name='apmaterno'
						style={errors?.apmaterno ? { borderColor: "red" } : {}}
						value={data?.apmaterno}
						onChange={formChangeHandler}
					/>
				</div>
			</div>
			<div className='row'>
				<div className='col-sm-12 col-md-6'>
					<label style={{ color: "white" }}>Teléfono</label>
					<input
						className='form-control'
						maxLength={10}
						name='telefono'
						value={data?.telefono}
						onChange={formChangeHandler}
					/>
				</div>
				<div className='col-sm-12 col-md-6'>
					<label style={{ color: "white" }}>Correo electrónico</label>
					<input
						className='form-control'
						type='text'
						name='email'
						value={data?.email}
						onChange={formChangeHandler}
					/>
				</div>
			</div>
			<div className='row'>
				<div className='col-sm-12 col-md-6'>
					<label style={{ color: "white" }}>Fecha de Nacimiento</label>
					<Calendario
						value={data?.cumpleanios}
						handleChange={(date) => {

							calcularEdad(date)

							setData({
								...data,
								cumpleanios: date,
							});
						}}
					/>
				</div>
				<div className='col-sm-12 col-md-6'>
					<label style={{ color: "white" }}>Género*</label>
					<div sytle={{ width: "100%" }}>
						<div className='custom-radio d-inline-block'>
							<input
								type='radio'
								id={type + "fem"}
								name='genero'
								value='2'
								checked={data?.genero == 2}
								onChange={formChangeHandler}
							/>
							<label htmlFor={type + "fem"} style={{ color: "white" }}>
								Fem.
							</label>
						</div>
						<div className='custom-radio d-inline-block ml-masc'>
							<input
								type='radio'
								id={type + "masc"}
								name='genero'
								value='1'
								checked={data?.genero == 1}
								onChange={formChangeHandler}
							/>
							<label
								htmlFor={type + "masc"}
								style={{ color: "white", marginLeft: "2em" }}>
								Masc.
							</label>
						</div>
					</div>
				</div>
			</div>
			<div className='row'>
				<div className='col-sm-12 col-md-6'>
					<label style={{ color: "white" }}>Código Postal</label>
					<input
						className='form-control'
						type='text'
						maxLength={5}
						name='cp'
						value={data?.cp}
						style={errors?.cp ? { borderColor: "red" } : {}}
						onChange={formChangeHandler}
					/>
				</div>
				<div className='col-sm-12 col-md-6'>
					<label style={{ color: "white" }}>Nacionalidad</label>
					<div sytle={{ width: "100%" }}>
						<div className='custom-radio d-inline-block'>
							<input
								type='radio'
								id='maxicano'
								name='nacionalidad'
								value='1'
								checked={data?.nacionalidad == 1}
								onChange={formChangeHandler}
							/>
							<label htmlFor='maxicano' style={{ color: "white" }}>
								Mexicana
							</label>
						</div>
						<div className='custom-radio d-inline-block ml-masc'>
							<input
								type='radio'
								id='otro'
								name='nacionalidad'
								value='2'
								checked={data?.nacionalidad == 2}
								onChange={formChangeHandler}
							/>
							<label
								htmlFor='otro'
								style={{ color: "white", marginLeft: "2em" }}>
								Otro
							</label>
						</div>
					</div>
				</div>
			</div>
			<div className='row'>
				<div className='col-sm-12 col-md-6'>
					<label style={{ color: "white" }}>Estado</label>
					<div className='custom-select-container'>
						<select
							className='form-control'
							name='state'
							style={errors?.state ? { borderColor: "red" } : {}}
							value={data.state}
							onChange={(e) => formChangeHandler(e)}>
							<option value={0} disabled selected>
								Seleccione
							</option>
							{data?.estado?.map((item, index) => {
								return (
									<option
										selected={item === data.state}
										key={item + index}
										value={item}>
										{item}
									</option>
								);
							})}
						</select>
						<span className='custom-arrow'></span>
					</div>
				</div>
				<div className='col-sm-12 col-md-6'>
					<label style={{ color: "white" }}>Calle</label>
					<input
						className='form-control'
						type='text'
						name='street'
						value={data?.street}
						style={errors?.street ? { borderColor: "red" } : {}}
						onChange={formChangeHandler}
					/>
				</div>
			</div>
			<div className='row'>
				<div className='col-sm-12 col-md-6'>
					<label style={{ color: "white" }}>Municipio / Delegación</label>
					<div className='custom-select-container'>
						<select
							className='form-control'
							name='delegation'
							value={data?.delegation}
							style={errors?.delegation ? { borderColor: "red" } : {}}
							onChange={(e) => formChangeHandler(e)}>
							<option value={0} disabled selected>
								Seleccione
							</option>
							{data?.municipio?.map((item, index) => {
								return (
									<option
										selected={item === data.delegation}
										key={item + index}
										value={item}>
										{item}
									</option>
								);
							})}
						</select>
						<span className='custom-arrow'></span>
					</div>
				</div>
				<div className='col-sm-12 col-md-6'>
					<label style={{ color: "white" }}>Colonia</label>
					<select
						className='form-control'
						name='colonia'
						style={errors?.colonia ? { borderColor: "red" } : {}}
						value={data?.colonia}
						onChange={formChangeHandler}>
						<option value={0} selected>
							Seleccione
						</option>
						{data?.colony?.map((item) => (
							<option
								
								key={item}
								value={item}>
								{item}
							</option>
						))}
					</select>
					{/* <input
						className='form-control'
						type='text'
						name='colony'
						value={data?.colony}
						style={errors?.colony ? { borderColor: "red" } : {}}
						onChange={formChangeHandler}
					/> */}
				</div>
			</div>

			<div className='row'>
				<div className='col-sm-12 text-center'>
					<Button onClick={() => validateForm(1)}>Siguiente</Button>
				</div>
			</div>
		</>
	);
};

const calcularEdad = (fecha) => {
    var hoy = new Date()
    var cumpleanos = new Date(fecha)
    var edad = hoy.getFullYear() - cumpleanos.getFullYear()
    var m = hoy.getMonth() - cumpleanos.getMonth()

    if (m < 0 || (m === 0 && hoy.getDate() < cumpleanos.getDate())) {
        edad--
    }

    return edad
}

const Step2 = ({
	errors,
	data,
	onYearChange,
	years,
	selectedYear,
	disabled,
	formChangeHandler,
	description,
	onMarcaChange,
	marca,
	onSubMarcaChange,
	subMarca,
	selectedMarca,
	selectedSubMarca,
	tab,
	onClickHandler,
	validateForm,
}) => (
	<>
		<div className='row'>
			<div className='col-sm-12 col-md-4'>
				<label style={{ color: "white" }}>Año del automóvil</label>

				<div className='custom-select-container'>
					<select
						className='form-control'
						name='Country'
						id='years'
						style={errors?.selectedYear ? { borderColor: "red" } : {}}
						value={selectedYear}
						onChange={(e) => onYearChange(e.target.value)}>
						<option value={0} disabled selected>
							Seleccione
						</option>
						{years?.map((item) => (
							<option key={item.modelo} value={item.modelo}>
								{item.modelo}
							</option>
						))}
					</select>
					<span className='custom-arrow'></span>
				</div>
			</div>
			<div className='col-sm-12 col-md-4'>
				<label style={{ color: "white" }}>Marca</label>
				<div
					className={`custom-select-container ${
						disabled?.marca && `disabled`
					}`}>
					<select
						className='form-control'
						disabled={disabled?.marca}
						name='Country'
						id='marca'
						style={errors?.selectedMarca ? { borderColor: "red" } : {}}
						value={selectedMarca}
						onChange={(e) => onMarcaChange(e.target.value)}>
						<option value={0} selected>
							Seleccione marca
						</option>
						{marca?.map((item) => (
							<option
								key={item.marca}
								selected={item === selectedMarca}
								value={item.marca}>
								{item.marca}
							</option>
						))}
					</select>
					<span className='custom-arrow'></span>
				</div>
			</div>
			<div className='col-sm-12 col-md-4'>
				<label style={{ color: "white" }}>Submarca</label>
				<div
					className={`custom-select-container ${
						disabled?.submarca && `disabled`
					}`}>
					<select
						className='form-control'
						disabled={disabled?.subMarca}
						name='Country'
						id='submaraca'
						style={errors?.selectedSubMarca ? { borderColor: "red" } : {}}
						value={selectedSubMarca}
						onChange={(e) => onSubMarcaChange(e.target.value)}>
						<option value={0} selected>
							Seleccione submarca
						</option>
						{subMarca?.map((item) => (
							<option
								key={item.submarca}
								selected={item === selectedSubMarca}
								value={item.submarca}>
								{item.submarca}
							</option>
						))}
					</select>
					<span className='custom-arrow'></span>
				</div>
			</div>
		</div>
		<div className='row mb-2'>
			<div className='col-sm-12'>
				<label style={{ color: "white" }}>Descripción de la unidad</label>
				<div className='custom-select-container'>
					<select
						className='form-control'
						name='descripcion'
						style={errors?.descripcion ? { borderColor: "red" } : {}}
						onChange={(e) => formChangeHandler(e)}>
						<option value='' selected>
							Seleccione
						</option>
						{description?.map((item) => {
							return (
								<option key={item.version} value={item.version}>
									{item.descripcion}
								</option>
							);
						})}
					</select>
					<span className='custom-arrow'></span>
				</div>
			</div>
		</div>
		<div className='row mt-2'>
			<div className='col-sm-12'>
				<div className='form-group'>
					<input
						type='checkbox'
						id='acceptTerms'
						style={errors?.acceptTerms ? { borderColor: "red" } : {}}
						name='acceptTerms'
						checked={data?.acceptTerms}
						onChange={formChangeHandler}
					/>
					<label htmlFor='acceptTerms'>
						He leído y acepto los términos y condiciones de bajatuseguro.
					</label>
				</div>
			</div>
			<div className='col-sm-12'>
				<div className='form-group'>
					<input
						type='checkbox'
						id='acceptPrivacy'
						name='acceptPrivacy'
						style={errors?.acceptPrivacy ? { borderColor: "red" } : {}}
						checked={data?.acceptPrivacy}
						onChange={formChangeHandler}
					/>
					<label htmlFor='acceptPrivacy'>
						He leído y estoy de acuerdo con el Aviso de Privacidad.
					</label>
				</div>
			</div>
		</div>
		<div className='row'>
			<div className='col-sm-12 text-center'>
				{tab === 1 ? (
					<Button
						onClick={() => validateForm(2)}
						style={tab === 2 ? { marginTop: "0px" } : null}>
						Alias de la póliza
					</Button>
				) : (
					<Button
						onClick={() => onClickHandler()}
						style={tab === 2 ? { marginTop: "0px" } : null}>
						Cotizar
					</Button>
				)}
			</div>
		</div>
	</>
);

export default AutoForm;

const Title = styled.p`
	font-size: 40px;
	color: white;

	@media (max-width: 768px) {
		font-size: 24px;
		margin-bottom: 0px;
	}
`;

const Tabs = styled.p`
	font-size: 29px;
	color: white;
	width: 20px;
	cursor: pointer;
	&:first-child {
		margin-right: 12px;
	}
`;

export const Button = styled.button`
	background: #f89900;
	border: 3px solid white;
	color: white;
	text-align: center;

	padding: 11px;
	border-radius: 100px;
	width: 200px;
	margin-top: 10%;
	margin-left: auto;
	margin-right: auto;
	margin-bottom: 7%;
`;

export const Wrapper = styled.section`
	align-items: center;
	min-height: 550px;
	background: #5a68a1;
	border-radius: 20px;
	height: auto;
	margin-left: auto;
	margin-right: auto;
	height: auto;
	@media (max-width: 768px) {
		margin-top: 17%;
	}

	.form-group {
		display: block;
		margin-bottom: 15px;

		@media (max-width: 768px) {
			margin-bottom: 5px;
		}
	}

	.form-group input {
		padding: 0;
		height: initial;
		width: initial;
		margin-bottom: 0;
		display: none;
		cursor: pointer;
	}

	.form-group label {
		position: relative;
		cursor: pointer;
		color: white;
	}

	.form-group label:before {
		content: "";
		-webkit-appearance: none;
		background-color: transparent;
		border: 2px solid white;
		box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05),
			inset 0px -15px 10px -12px rgba(0, 0, 0, 0.05);
		padding: 10px;
		display: inline-block;
		position: relative;
		vertical-align: middle;
		cursor: pointer;
		margin-right: 5px;
	}

	.form-group input:checked + label:after {
		content: "";
		display: block;
		position: absolute;
		top: 2px;
		left: 9px;
		width: 6px;
		height: 14px;
		border: solid #f89900;
		border-width: 0 2px 2px 0;
		transform: rotate(45deg);
	}

	[type="radio"]:checked,
	[type="radio"]:not(:checked) {
		position: absolute;
		left: -9999px;
	}
	[type="radio"]:checked + label,
	[type="radio"]:not(:checked) + label {
		position: relative;
		padding-left: 28px;
		cursor: pointer;
		line-height: 20px;
		display: inline-block;
		color: #666;
	}
	[type="radio"]:checked + label:before,
	[type="radio"]:not(:checked) + label:before {
		content: "";
		position: absolute;
		left: 0;
		top: 0;
		width: 18px;
		height: 18px;
		border: 1px solid #ddd;
		border-radius: 100%;
		background: #fff;
	}
	[type="radio"]:checked + label:after,
	[type="radio"]:not(:checked) + label:after {
		content: "";
		width: 18px;
		height: 18px;
		border: 2px solid white;
		background: #3cdbc0;
		position: absolute;
		border-radius: 100%;
		-webkit-transition: all 0.2s ease;
		transition: all 0.2s ease;
	}
	[type="radio"]:not(:checked) + label:after {
		opacity: 0;
		-webkit-transform: scale(0);
		transform: scale(0);
	}
	[type="radio"]:checked + label:after {
		opacity: 1;
		-webkit-transform: scale(1);
		transform: scale(1);
		left: 0;
	}

	.disabled {
		select {
			opacity: 0.8 !important;
		}
	}
`;
